export const GET_REQUEST_USER_TRANSFERS_START = "GET_REQUEST_USER_TRANSFERS_START";
export const GET_REQUEST_USER_TRANSFERS_SUCCESS = "GET_REQUEST_USER_TRANSFERS_SUCCESS";
export const GET_REQUEST_USER_TRANSFERS_ERROR = "GET_REQUEST_USER_TRANSFERS_ERROR";

export const POST_REQUEST_USER_TRANSFERS_START = "POST_REQUEST_USER_TRANSFERS_START";
export const POST_REQUEST_USER_TRANSFERS_SUCCESS = "POST_REQUEST_USER_TRANSFERS_SUCCESS";
export const POST_REQUEST_USER_TRANSFERS_ERROR = "POST_REQUEST_USER_TRANSFERS_ERROR";